import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getQuestionsAndAnswers } from "../../../store/selectors";
import { useDispatch } from "react-redux";
import { appraisalSlice } from "../../../store/slices/Appraisal";
import {
  defaultAnswerState,
  questionPresentationContent
} from "../../../data/QuestionPresentation";
import { sortAnswers } from "../../helpers";

function useRadioAndCheckboxQuestionCompact({ question }) {
  const dispatch = useDispatch();
  const questionsAndAnswers = useSelector(getQuestionsAndAnswers);
  const storedAnswer = questionsAndAnswers && questionsAndAnswers[question.id];
  const noDamageAnswer = question.answers[question.answers.length - 1];
  const noDamageAnswerID = noDamageAnswer.id;
  const answersForCheckbox = [...question.answers].slice(0, -1);
  const sortedAnswersForCheckbox = sortAnswers(answersForCheckbox);
  const checkBoxAnswerIds = answersForCheckbox.map((answer) => answer.id);

  const {
    groupName,
    component: { content }
  } = questionPresentationContent[question.id];

  let showCheckboxLabel;
  let showCheckboxValue;
  let labelForCheckbox;

  if ("showCheckboxLabel" in content) {
    ({ showCheckboxLabel, showCheckboxValue, labelForCheckbox } =
      content);
  }

  const [selectAnswer, setSelectAnswer] = useState(defaultAnswerState);

  useEffect(() => {
    setSelectAnswer(
      (storedAnswer && storedAnswer?.includes(showCheckboxValue)) ||
        storedAnswer?.some((answerId) => checkBoxAnswerIds.includes(answerId))
        ? [showCheckboxValue]
        : storedAnswer && storedAnswer?.includes(noDamageAnswerID)
        ? [noDamageAnswerID]
        : defaultAnswerState
    );
  }, [question.selectedAnswer, questionsAndAnswers, question.id, storedAnswer]);

  const handleAnswerChange = (answerId) => {
    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    dispatch(
      appraisalSlice.actions.updateConditionalAnswersSubmitted(question.id)
    );
    setSelectAnswer([answerId]);
    dispatch(
      appraisalSlice.actions.setQuestionsAndAnswers({
        [question.id]: [answerId]
      })
    );
  };

  const handleCheckboxChange = (answerId, checked) => {
    dispatch(appraisalSlice.actions.setAnswersChanged(true));
    dispatch(
      appraisalSlice.actions.updateConditionalAnswersSubmitted(question.id)
    );
    if (storedAnswer[0] === showCheckboxValue) {
      dispatch(
        appraisalSlice.actions.setQuestionsAndAnswers({
          [question.id]: [answerId]
        })
      );
      return;
    }
    if (checked) {
      const checkboxAnswerAdded = [...storedAnswer, answerId];
      dispatch(
        appraisalSlice.actions.setQuestionsAndAnswers({
          [question.id]: checkboxAnswerAdded
        })
      );
    } else {
      const checkboxAnswerRemoved = [...storedAnswer].filter(
        (answer) => answer !== answerId
      );
      dispatch(
        appraisalSlice.actions.setQuestionsAndAnswers({
          [question.id]: checkboxAnswerRemoved
        })
      );
    }
  };

  return {
    noDamage: noDamageAnswerID,
    handleSelectChange: handleAnswerChange,
    handleCheckboxChange,
    answersForCheckbox: sortedAnswersForCheckbox,
    selectAnswer,
    groupName: groupName || "",
    questionString: question.content,
    noDamageLabel: noDamageAnswer.label,
    showCheckboxLabel,
    showCheckboxValue,
    labelForCheckbox
  };
}

export default useRadioAndCheckboxQuestionCompact;
